module.exports = __webpack_public_path__ + "static/IntroBG-4df9a9f8dedf9e377f40c55132c6b2c3.jpg";